export { default } from "controllers/inspection_reports/new"
